import type { VocabularyCategory } from '@/db/Types'

/**
 * Canonical display order for vocabulary categories.
 * Used by tables, filter pills, and grouped views.
 */
export const VOCABULARY_CATEGORY_ORDER: VocabularyCategory[] = [
	'formation',
	'route',
	'blocking',
	'motion',
	'protection',
	'modifier',
]

/**
 * Singular category labels for display in badges, dropdowns, and detail views.
 */
export const VOCABULARY_CATEGORY_LABELS: Record<VocabularyCategory, string> = {
	formation: 'Formation',
	route: 'Route',
	blocking: 'Run Scheme',
	motion: 'Motion',
	protection: 'Protection',
	modifier: 'Modifier',
}

/**
 * Plural category labels for group headers and tab counts.
 */
export const VOCABULARY_CATEGORY_LABELS_PLURAL: Record<VocabularyCategory, string> = {
	formation: 'Formations',
	route: 'Routes',
	blocking: 'Run Schemes',
	motion: 'Motions',
	protection: 'Protections',
	modifier: 'Modifiers',
}
